var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranscript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1506",
    "data-name": "Group 1506",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.846,
    height: 28.04,
    viewBox: "0 0 32.846 28.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 32.846,
    height: 28.04,
    fill: "#fa0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M32.846,5.378V19.26a6.305,6.305,0,0,1-5.79,5.373c-1.72.119-3.55-.11-5.281.029-2.521,1.377-4.209,5.018-7.448,2.529-.709-.545-2.505-2.391-3.23-2.528-2.643-.238-5.5.517-7.915-.85A6.2,6.2,0,0,1,.088,18.976c-.281-4.349.219-9,0-13.377A6.256,6.256,0,0,1,5.878,0H27a6.329,6.329,0,0,1,5.851,5.377m-27.4,4.943a1.512,1.512,0,0,0,.112,2.989H19.186a1.512,1.512,0,0,0,0-3.005Zm19.448,0a1.513,1.513,0,0,0,.112,2.989,10.568,10.568,0,0,0,2.871-.134,1.538,1.538,0,0,0-.044-2.757,11.382,11.382,0,0,0-2.939-.1M5.449,16.462a1.518,1.518,0,0,0-.255,2.908c1.111.349,2.559-.065,2.559-1.421,0-1.3-1.213-1.644-2.3-1.487m6.653,0a1.511,1.511,0,0,0,.173,2.992,23.19,23.19,0,0,0,3.386-.009,1.511,1.511,0,0,0-.119-3,22.277,22.277,0,0,0-3.44.019m9.212,0a1.509,1.509,0,0,0,.236,2.993c1.894.141,3.968-.105,5.881-.01a1.51,1.51,0,0,0-.182-3c-1.909-.142-4.007.1-5.936.019",
    transform: "translate(0 -0.001)",
    fill: "#fa0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscript);
export default __webpack_public_path__ + "static/media/transcript.752137456d5ed7bf5c0f3f80c5b1ba62.svg";
export { ForwardRef as ReactComponent };